import { Formik } from 'formik'
import { useEffect, useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import 'react-toggle/style.css'
import api from '../../../config/AxiosInstance'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import { StagingAreaAddSchema } from '../../../utils/validationSchema'
import CustomButton from '../../Button/CustomButton'
import CustomCloseButton from '../../Button/CustomCloseButton'
import TextField from '../../Input/TextInput'

function ModalUpdateStagingArea(props) {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const fetchStagingArea = async (id) => {
    try {
      setLoading(true)
      const res = await api.get(`master/stagings/${id}`)
      setData(res.data.data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (values, actions) => {
    try {
      setLoadingSubmit(true)
      const response = await api.post(`/master/stagings/${data.id}`, values)
      if (response.data.success) {
        props.onHide()
        props.refreshData()
        Common.showPopUpSuccessMessage(response.data.message)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmit(false)
    }
  }

  useEffect(
    function () {
      if (props.id !== 0) {
        fetchStagingArea(props.id)
      }
    },
    [props.id, props.show]
  )

  return (
    <Modal {...props} centered>
      <Modal.Header closeButton>
        <Modal.Title>Update Staging Area</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <Formik
            initialValues={{
              staging_name: data.name,
              block_total: data.block_total
            }}
            enableReinitialize={true}
            validateOnBlur={true}
            validationSchema={StagingAreaAddSchema}
            onSubmit={(values) => {
              handleSubmit(values)
            }}
          >
            {({
              handleBlur,
              handleSubmit,
              handleChange,
              values,
              setFieldValue,
              errors,
              touched,
              isValid
            }) => {
              return (
                <Form className="d-grid gap-2" onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <TextField
                        id="staging_name"
                        label="NAME"
                        name="staging_name"
                        value={values.staging_name}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        className="mb-1"
                        required={true}
                      />
                    </Col>
                    <Col md={12}>
                      <TextField
                        id="block_total"
                        label="TOTAL BLOCK"
                        name="block_total"
                        value={values.block_total}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        touched={touched}
                        errors={errors}
                        className="mb-1"
                        required={true}
                        type="number"
                      />
                    </Col>
                  </Row>
                  <Modal.Footer className="mt-3">
                    <CustomCloseButton onClick={props.onHide} />
                    <CustomButton
                      onClick={handleSubmit}
                      variant={
                        !isValid || loadingSubmit ? 'secondary' : 'warning'
                      }
                      disabled={!isValid || loadingSubmit}
                      text={loadingSubmit ? 'Loading...' : 'Update'}
                      classNameValue={`text-white ${
                        !isValid || loadingSubmit ? 'opacity-25' : ''
                      }`}
                    />
                  </Modal.Footer>
                </Form>
              )
            }}
          </Formik>
        )}
        {loading && (
          <div className="d-flex justify-content-center">
            <div className="spinner-border text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default ModalUpdateStagingArea
